export default {
	BOX: 'box',
}


// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/ItemTypes.js